import React from 'react';
import MSelectListView from './MSelectList.view';
import { IDropdownListOption } from './MSelectList.model';

interface Props<ValueType extends string | number> {
  className?: string;
  listRef: React.RefObject<HTMLUListElement>;
  options: IDropdownListOption<ValueType>[];
  selected?: ValueType | null;
  onOptionClick: (value: ValueType, index: number) => void;
}

const MSelectList = <ValueType extends string | number>(props: React.PropsWithChildren<Props<ValueType>>): JSX.Element => {
  return (
    <MSelectListView
      listRef={props.listRef}
      className={props.className}
      selected={props.selected}
      onOptionClick={props.onOptionClick}
      options={props.options}
    >
      {props.children}
    </MSelectListView>
  );
};

MSelectList.displayName = 'MSelectList';
MSelectList.defaultProps = {};

export default MSelectList;
